(function(){
'use strict';
var leafletPromise=null;
var leafletCssId='pf-leaflet-css';
function loadLeaflet(){
  if(window.L)return Promise.resolve(window.L);
  if(leafletPromise)return leafletPromise;
  leafletPromise=new Promise(function(resolve,reject){
    if(!document.getElementById(leafletCssId)){
      var link=document.createElement('link');link.id=leafletCssId;link.rel='stylesheet';
      link.href='https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';document.head.appendChild(link);
    }
    var existing=document.querySelector('script[data-pf-leaflet]');
    if(existing){existing.addEventListener('load',function(){resolve(window.L)});existing.addEventListener('error',reject);return;}
    var s=document.createElement('script');s.src='https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';s.async=true;s.dataset.pfLeaflet='1';
    s.onload=function(){resolve(window.L)};s.onerror=function(){reject(new Error('Map library could not load'));};document.head.appendChild(s);
  });
  return leafletPromise;
}
function num(v){v=Number(v);return Number.isFinite(v)?v:null}
function point(v){if(!v)return null;var lat=num(v.latitude),lon=num(v.longitude);return lat==null||lon==null?null:{latitude:lat,longitude:lon,heading:num(v.heading),accuracy_m:num(v.accuracy_m),speed_mps:num(v.speed_mps)}}
function hav(a,b){
  if(!a||!b)return Infinity;var R=6371000,r=Math.PI/180,dLat=(b.latitude-a.latitude)*r,dLon=(b.longitude-a.longitude)*r;
  var x=Math.sin(dLat/2)*Math.sin(dLat/2)+Math.cos(a.latitude*r)*Math.cos(b.latitude*r)*Math.sin(dLon/2)*Math.sin(dLon/2);
  return 2*R*Math.atan2(Math.sqrt(x),Math.sqrt(1-x));
}
function distanceText(m){m=Number(m);if(!Number.isFinite(m))return '—';return m<1000?Math.max(10,Math.round(m/10)*10)+' m':(m/1000).toFixed(m<10000?1:0)+' km'}
function etaText(s){s=Number(s);if(!Number.isFinite(s))return '—';var m=Math.max(1,Math.ceil(s/60));return m<60?m+' min':Math.floor(m/60)+'h '+(m%60)+'m'}
function markerIcon(L,kind,heading){
  var cls=kind==='destination'?'pf-nav-pin pf-nav-pin--destination':'pf-nav-pin pf-nav-pin--moving';
  var inner=kind==='destination'?'<span></span>':'<span style="transform:rotate('+(Number.isFinite(Number(heading))?Number(heading):0)+'deg)">➤</span>';
  return L.divIcon({className:'',html:'<div class="'+cls+'">'+inner+'</div>',iconSize:[34,34],iconAnchor:[17,17]});
}
function ensureShell(container,opts){
  if(container.dataset.pfNavShell==='1')return;
  container.dataset.pfNavShell='1';
  container.classList.add('pf-nav');
  if(opts&&opts.compact)container.classList.add('pf-nav--compact');
  container.innerHTML=
    '<div class="pf-nav__banner"><div class="pf-nav__maneuver" data-pf-nav-maneuver>↑</div><div class="pf-nav__instruction"><span data-pf-nav-prefix>LIVE ROUTE</span><strong data-pf-nav-instruction>Connecting to route…</strong><small data-pf-nav-next></small></div><div class="pf-nav__tools"><button type="button" data-pf-nav-recenter aria-label="Recenter map" title="Recenter">◎</button><button type="button" data-pf-nav-voice aria-label="Toggle voice guidance" title="Voice guidance">🔊</button></div></div>'+
    '<div class="pf-nav__map" data-pf-nav-map></div>'+
    '<div class="pf-nav__footer"><div><span>Distance</span><strong data-pf-nav-distance>—</strong></div><div><span>ETA</span><strong data-pf-nav-eta>—</strong></div><div><span>GPS</span><strong data-pf-nav-signal>Connecting</strong></div></div>'+
    '<div class="pf-nav__note" data-pf-nav-note>Live road navigation updates automatically.</div>';
}
function maneuverGlyph(step){
  if(!step)return '↑';var t=String(step.maneuver_type||'').toLowerCase(),m=String(step.maneuver_modifier||'').toLowerCase();
  if(t==='arrive')return '●';if(t==='roundabout'||t==='rotary')return '↻';if(/left/.test(m))return '↰';if(/right/.test(m))return '↱';if(t==='merge'||t==='fork')return '⇢';return '↑';
}
function instructionState(route){
  var steps=route&&Array.isArray(route.steps)?route.steps:[];
  if(!steps.length)return {instruction:route&&route.current_instruction||'Continue on route',distance:null,glyph:'↑',next:''};
  var current=steps[0],next=steps.length>1?steps[1]:steps[0];
  if(steps.length>1&&String(current.maneuver_type||'').toLowerCase()!=='arrive'){
    return {instruction:next.instruction||'Continue on route',distance:Number(current.distance_m||0),glyph:maneuverGlyph(next),next:current.road_name?('Continue on '+current.road_name):''};
  }
  return {instruction:current.instruction||'Continue on route',distance:Number(current.distance_m||0),glyph:maneuverGlyph(current),next:''};
}
function speak(text){
  if(!text||!window.speechSynthesis||!window.SpeechSynthesisUtterance)return;
  try{window.speechSynthesis.cancel();var u=new SpeechSynthesisUtterance(text);u.rate=1.03;u.pitch=1;u.volume=.9;window.speechSynthesis.speak(u);}catch(_e){}
}
function createMapState(container,opts){
  return loadLeaflet().then(function(L){
    ensureShell(container,opts||{});
    var mapHost=container.querySelector('[data-pf-nav-map]');
    var map=L.map(mapHost,{zoomControl:false,attributionControl:true,preferCanvas:true});
    L.control.zoom({position:'bottomright'}).addTo(map);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:19,attribution:'&copy; OpenStreetMap contributors'}).addTo(map);
    var state={L:L,map:map,route:null,moving:null,destination:null,fitted:false,lastSpoken:'',lastSpeechAt:0,lastVoiceKey:'',voiceEnabled:false,observer:false,currentRoute:null,lastLivePoint:null};
    container.__pfNavState=state;
    var recenter=container.querySelector('[data-pf-nav-recenter]');
    if(recenter)recenter.addEventListener('click',function(){
      var p=state.lastLivePoint||point(state.currentRoute&&state.currentRoute.origin);
      if(p){state.map.setView([p.latitude,p.longitude],Math.max(16,state.map.getZoom()),{animate:true});}
    });
    var voice=container.querySelector('[data-pf-nav-voice]');
    if(voice)voice.addEventListener('click',function(){
      state.voiceEnabled=!state.voiceEnabled;
      voice.textContent=state.voiceEnabled?'🔊':'🔇';
      voice.setAttribute('aria-pressed',state.voiceEnabled?'true':'false');
      if(!state.voiceEnabled&&window.speechSynthesis){try{window.speechSynthesis.cancel();}catch(_e){}}
    });
    return state;
  });
}
function getState(container,opts){return container.__pfNavState?Promise.resolve(container.__pfNavState):createMapState(container,opts)}
function updateLabels(container,route,livePoint,opts){
  var observer=!!(opts&&opts.observer),st=instructionState(route),instruction=st.instruction,dist=st.distance;
  if(observer){
    instruction=(route&&route.moving_subject)==='CUSTOMER'?'Customer is on the way':'Responder is on the way';
    st.glyph=(route&&route.moving_subject)==='CUSTOMER'?'◎':'●';
    st.next=distanceText(route&&route.distance_m)+' away · '+etaText(route&&route.duration_s)+' ETA';
  }else if(dist!=null&&dist>0){
    instruction='In '+distanceText(dist)+', '+instruction.charAt(0).toLowerCase()+instruction.slice(1);
  }
  var i=container.querySelector('[data-pf-nav-instruction]');if(i)i.textContent=instruction;
  var n=container.querySelector('[data-pf-nav-next]');if(n)n.textContent=st.next||((opts&&opts.subtitle)||'');
  var g=container.querySelector('[data-pf-nav-maneuver]');if(g)g.textContent=st.glyph;
  var d=container.querySelector('[data-pf-nav-distance]');if(d)d.textContent=distanceText(route&&route.distance_m);
  var e=container.querySelector('[data-pf-nav-eta]');if(e)e.textContent=etaText(route&&route.duration_s);
  var s=container.querySelector('[data-pf-nav-signal]');if(s)s.textContent=route&&route.stale?'Delayed':(livePoint?'Live':'Waiting');
  var p=container.querySelector('[data-pf-nav-prefix]');if(p)p.textContent=(opts&&opts.prefix)||((route&&route.moving_subject)==='CUSTOMER'?'CUSTOMER LIVE ROUTE':'RESPONDER LIVE ROUTE');
  var note=container.querySelector('[data-pf-nav-note]');
  if(note)note.textContent=(route&&route.production_ready===false?'Pre-launch road routing active. ':'')+((opts&&opts.note)||'Route, distance and ETA update from live GPS.');
  return instruction;
}
function liveManeuverState(route,p){
  if(!route||!p||!Array.isArray(route.steps)||!route.steps.length)return null;
  var steps=route.steps,idx=steps.length>1?1:0,target=steps[idx],loc=point(target.location);
  if(!loc)return null;
  var m=hav(p,loc);
  return {distance_m:m,instruction:target.instruction||'Continue on route',glyph:maneuverGlyph(target),road_name:target.road_name||''};
}
function updateLiveManeuver(container,p,state){
  if(!state||state.observer||!state.currentRoute)return;
  var live=liveManeuverState(state.currentRoute,p);if(!live)return;
  var text='In '+distanceText(live.distance_m)+', '+live.instruction.charAt(0).toLowerCase()+live.instruction.slice(1);
  var i=container.querySelector('[data-pf-nav-instruction]');if(i)i.textContent=text;
  var g=container.querySelector('[data-pf-nav-maneuver]');if(g)g.textContent=live.glyph;
  var n=container.querySelector('[data-pf-nav-next]');if(n)n.textContent=live.road_name?('Then continue on '+live.road_name):'';
  if(state.voiceEnabled){
    var threshold=live.distance_m<=25?25:(live.distance_m<=70?70:(live.distance_m<=180?180:null));
    if(threshold){
      var key=String(live.instruction)+'|'+threshold;
      if(state.lastVoiceKey!==key){
        state.lastVoiceKey=key;
        speak((threshold<=25?'Now, ':'In '+distanceText(live.distance_m)+', ')+live.instruction);
      }
    }
  }
}
function applyRoute(container,route,opts){
  return getState(container,opts).then(function(state){
    var L=state.L,origin=point(route&&route.origin),destination=point(route&&route.destination);
    if(!origin||!destination)throw new Error('Route coordinates unavailable');
    var coords=route.geometry&&Array.isArray(route.geometry.coordinates)?route.geometry.coordinates.map(function(c){return [Number(c[1]),Number(c[0])]})
      :[[origin.latitude,origin.longitude],[destination.latitude,destination.longitude]];
    if(state.route)state.route.setLatLngs(coords);else state.route=L.polyline(coords,{weight:6,opacity:.95,lineJoin:'round',lineCap:'round'}).addTo(state.map);
    if(state.moving){state.moving.setLatLng([origin.latitude,origin.longitude]);state.moving.setIcon(markerIcon(L,'moving',origin.heading));}
    else state.moving=L.marker([origin.latitude,origin.longitude],{icon:markerIcon(L,'moving',origin.heading),zIndexOffset:500}).addTo(state.map);
    if(state.destination)state.destination.setLatLng([destination.latitude,destination.longitude]);
    else state.destination=L.marker([destination.latitude,destination.longitude],{icon:markerIcon(L,'destination'),zIndexOffset:400}).addTo(state.map);
    if(!state.fitted){state.map.fitBounds(L.latLngBounds(coords),{padding:[45,45],maxZoom:16});state.fitted=true;}
    else if(!opts||opts.follow!==false){state.map.panTo([origin.latitude,origin.longitude],{animate:true,duration:.65});if(state.map.getZoom()<15)state.map.setZoom(15);}
    state.map.invalidateSize(false);
    state.currentRoute=route;
    state.lastLivePoint=origin;
    state.voiceEnabled=state.voiceEnabled||!!(opts&&opts.voice);
    state.observer=!!(opts&&opts.observer);
    var voiceBtn=container.querySelector('[data-pf-nav-voice]');
    if(voiceBtn){voiceBtn.style.display=state.observer?'none':'';voiceBtn.textContent=state.voiceEnabled?'🔊':'🔇';voiceBtn.setAttribute('aria-pressed',state.voiceEnabled?'true':'false');}
    var instruction=updateLabels(container,route,origin,opts||{});
    if(opts&&opts.voice&&instruction&&instruction!==state.lastSpoken&&Date.now()-state.lastSpeechAt>6000){state.lastSpoken=instruction;state.lastSpeechAt=Date.now();speak(instruction);}
    return state;
  });
}
function setLivePoint(container,p){
  var state=container&&container.__pfNavState;if(!state)return;p=point(p);if(!p)return;
  state.lastLivePoint=p;
  if(state.moving){state.moving.setLatLng([p.latitude,p.longitude]);state.moving.setIcon(markerIcon(state.L,'moving',p.heading));}
  updateLiveManeuver(container,p,state);
}
function showError(container,message){
  if(!container)return;ensureShell(container,{});
  var i=container.querySelector('[data-pf-nav-instruction]');if(i)i.textContent=message||'Navigation unavailable';
  var s=container.querySelector('[data-pf-nav-signal]');if(s)s.textContent='Retrying';
}
function startNavigation(opts){
  opts=opts||{};var container=opts.container;if(!container)throw new Error('Navigation container required');
  if(container.__pfNavController)container.__pfNavController.stop();ensureShell(container,opts);
  var stopped=false,watch=null,lastRouteAt=0,lastRoutePoint=null,lastShareAt=0,routeBusy=false,wake=null,lastAcceptedPoint=null;
  function requestWake(){if(!('wakeLock' in navigator)||document.visibilityState!=='visible')return;navigator.wakeLock.request('screen').then(function(w){wake=w;}).catch(function(){});}
  function releaseWake(){if(wake){try{wake.release();}catch(_e){}wake=null;}}
  function doRoute(pos,force){
    if(routeBusy||stopped||typeof opts.requestRoute!=='function')return;
    var now=Date.now(),moved=lastRoutePoint?hav(lastRoutePoint,pos):Infinity;
    var speed=Number(pos&&pos.speed_mps),fast=Number.isFinite(speed)&&speed>7;
    var minAge=fast?5000:8000,minMove=fast?18:28;
    if(!force&&now-lastRouteAt<minAge&&moved<minMove)return;
    routeBusy=true;lastRouteAt=now;lastRoutePoint={latitude:pos.latitude,longitude:pos.longitude};
    var routed=null;
    Promise.resolve(opts.requestRoute(pos)).then(function(r){
      routeBusy=false;if(stopped)return;var route=r&&r.data?r.data:r;
      if(r&&r.error)throw new Error(r.error.message||'Road route unavailable');
      if(!route||!route.geometry)throw new Error('Road route unavailable');
      routed=route;
      return applyRoute(container,route,Object.assign({},opts,{voice:opts.voice!==false,follow:true}));
    }).then(function(){if(routed&&opts.onRoute)opts.onRoute(routed);}).catch(function(err){routeBusy=false;showError(container,err.message||'Road route unavailable');if(opts.onError)opts.onError(err);});
  }
  function onPosition(p){
    if(stopped)return;
    var c=p.coords,pos={latitude:c.latitude,longitude:c.longitude,accuracy_m:c.accuracy,heading:c.heading,speed_mps:c.speed};
    var accuracy=Number(c.accuracy);
    if(Number.isFinite(accuracy)&&accuracy>150&&lastAcceptedPoint){
      var weak=container.querySelector('[data-pf-nav-signal]');if(weak)weak.textContent='Weak GPS';
      return;
    }
    if(lastAcceptedPoint&&hav(lastAcceptedPoint,pos)<2&&(!Number.isFinite(Number(c.speed))||Number(c.speed)<1)){return;}
    lastAcceptedPoint={latitude:pos.latitude,longitude:pos.longitude};
    setLivePoint(container,pos);
    var sig=container.querySelector('[data-pf-nav-signal]');
    if(sig)sig.textContent=accuracy<=25?'Precise':(accuracy<=60?'Live':('±'+Math.round(accuracy)+' m'));
    if(typeof opts.shareLocation==='function'&&Date.now()-lastShareAt>=2800){lastShareAt=Date.now();Promise.resolve(opts.shareLocation(pos)).catch(function(){});}
    doRoute(pos,false);if(opts.onPosition)opts.onPosition(pos);
  }
  function onGeoError(err){showError(container,err&&err.code===1?'Allow precise location for live navigation.':'GPS signal unavailable. Retrying…');if(opts.onError)opts.onError(err);}
  getState(container,opts).then(function(){
    if(stopped)return;requestWake();
    if(!navigator.geolocation){showError(container,'This device does not support live GPS navigation.');return;}
    navigator.geolocation.getCurrentPosition(function(p){onPosition(p);doRoute({latitude:p.coords.latitude,longitude:p.coords.longitude,accuracy_m:p.coords.accuracy,heading:p.coords.heading,speed_mps:p.coords.speed},true);},onGeoError,{enableHighAccuracy:true,timeout:15000,maximumAge:0});
    watch=navigator.geolocation.watchPosition(onPosition,onGeoError,{enableHighAccuracy:true,timeout:15000,maximumAge:1500});
  }).catch(function(err){showError(container,err.message||'Map could not load.');});
  function visibility(){if(document.visibilityState==='visible')requestWake();else releaseWake();}
  document.addEventListener('visibilitychange',visibility);
  var controller={stop:function(){stopped=true;if(watch!=null&&navigator.geolocation)navigator.geolocation.clearWatch(watch);watch=null;releaseWake();document.removeEventListener('visibilitychange',visibility);if(container.__pfNavController===controller)container.__pfNavController=null;},refresh:function(){if(lastRoutePoint)doRoute(lastRoutePoint,true);}};
  container.__pfNavController=controller;return controller;
}
function stop(container){
  if(container&&container.__pfNavController)container.__pfNavController.stop();
  if(container&&container.__pfNavState){try{container.__pfNavState.map.remove();}catch(_e){}container.__pfNavState=null;container.dataset.pfNavShell='';}
}
window.ProFindEmergencyNav={renderRoute:applyRoute,startNavigation:startNavigation,setLivePoint:setLivePoint,showError:showError,stop:stop,distanceText:distanceText,etaText:etaText};
})();